import {
  LogoContainerShopify,
  LogoContainerTiendanube,
  LogoContainerVtex,
  LogoContainerWoo,
} from './LogoContainer';

export const logoComponentsByEcommerce = {
  shopify: LogoContainerShopify,
  tiendanube: LogoContainerTiendanube,
  vtex: LogoContainerVtex,
  woo: LogoContainerWoo,
};
